import { SCREEN_SM } from '@/common/constants/breakpoints';
import { useAppStore } from '@/common/stores/AppStore';
import { MediaSize } from '@/media/constants/sizeCodes';

export function useForwardPreviewMediaSize(): MediaSize {
  const { screenWidth } = useAppStore();

  return !!screenWidth && screenWidth < SCREEN_SM ? MediaSize.XSmall : MediaSize.Small;
}
